import { Badge } from "@qw/ui";
import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";

interface Props {
  characteristicAppetite: ProductHistoricalInsights["characteristicAppetite"];
}

const responseVariant = (response: string) => {
  switch (response.toLowerCase()) {
    case "preferred":
    case "target":
      return "green" as const;
    case "acceptable":
    case "standard":
      return "default" as const;
    case "conditional":
      return "amber" as const;
    case "avoid":
    case "decline":
    case "excluded":
      return "destructive" as const;
    default:
      return "secondary" as const;
  }
};

export const InsightsCharacteristicAppetiteSection: FC<Props> = ({ characteristicAppetite }) => {
  if (characteristicAppetite.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Risk Characteristics</h3>
      <div className="space-y-2">
        {characteristicAppetite.map((item) => (
          <div key={item.characteristicName} className="rounded-md border p-2 space-y-1">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium">{item.displayName}</span>
              <Badge variant={responseVariant(item.response)}>{item.response}</Badge>
            </div>
            {item.conditions && <p className="text-xs text-muted-foreground">{item.conditions}</p>}
            <Badge variant="outline" size="2xs">
              {item.importance}
            </Badge>
          </div>
        ))}
      </div>
    </div>
  );
};
